import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import type { IPost } from "../../types/post";

export const fetchPosts = createAsyncThunk<
    IPost[],
    { cursor?: string; replace?: boolean; username?: string | null; targetUsername?: string | null; filter?: "all" | "followed" }
>("posts/fetchPosts", async ({ cursor, username, targetUsername, filter }, thunkAPI) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/posts`, {
        params: { cursor, limit: 10, username, targetUsername, filter },
    });

    return response.data.body;
});

interface PostsState {
    posts: IPost[];
    loading: boolean;
    hasMore: boolean;
}

const initialState: PostsState = {
    posts: [],
    loading: false,
    hasMore: true,
};

const postsSlice = createSlice({
    name: "posts",
    initialState,
    reducers: {
        resetPosts: (state) => {
            state.posts = [];
            state.hasMore = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPosts.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPosts.fulfilled, (state, action) => {
                state.loading = false;

                const isReplace = action.meta.arg.replace;

                if (action.payload.length === 0) {
                    state.hasMore = false;
                }

                if (isReplace) {
                    state.posts = action.payload;
                    state.hasMore = true;
                } else {
                    state.posts.push(...action.payload);
                }
            })
            .addCase(fetchPosts.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { resetPosts } = postsSlice.actions;
export default postsSlice.reducer;
